import store from '@/store';

export default async (to, from, next) => {
    if (store.getters['auth/GUEST'] && store.getters['auth/AUTH_TOKEN']) {
        try {
            await store.dispatch('auth/FETCH_USER');
            await store.dispatch('notifications/SYNC_NOTIFICATIONS', {unread: 1, per_page: 100});
        } catch (e) {
            await store.dispatch('auth/LOGOUT');
        }
    }

    next();
}
